import type { ReactNode } from 'react';
import { LoadingBlock, StateBlock, Button } from '../ui';
import LoginScreen from './LoginScreen';
import { useSession, useUnauthorizedRedirect } from './session';

/** Gates the whole app behind a valid session cookie. */
export default function RequireSession({ children }: { children: ReactNode }) {
  const { data, isPending, isError, error, refetch } = useSession();
  useUnauthorizedRedirect();

  if (isPending) return <LoadingBlock label="Checking your session…" />;

  if (isError) {
    return (
      <div className="mx-auto max-w-lg px-4 py-16">
        <StateBlock
          tone="bad"
          title="Cannot reach the sign-in service"
          detail={(error as Error).message}
          action={
            <Button size="sm" onClick={() => void refetch()}>
              Try again
            </Button>
          }
        />
      </div>
    );
  }

  if (!data.authenticated) return <LoginScreen />;

  return <>{children}</>;
}
